export function base64UrlToUint8Array(value) {
  const padded = `${value}${"=".repeat((4 - value.length % 4) % 4)}`.replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(padded);
  return Uint8Array.from(raw, character => character.charCodeAt(0));
}

export function safePushTarget({ module, phone, storeId, eventId } = {}) {
  const validModule = ["inbox", "leads", "kanban", "prospeccao", "central", "deposito"].includes(module) ? module : "inbox";
  return "/?" + new URLSearchParams({
    module: validModule,
    phone: String(phone || "").replace(/[^\d+]/g, "").slice(0, 32),
    storeId: Number(storeId) > 0 ? String(Number(storeId)) : "",
    eventId: String(eventId || "").replace(/[^a-zA-Z0-9_-]/g, "").slice(0, 128),
  }).toString();
}

export function notificationOptions(payload = {}) {
  const eventId = String(payload.eventId || "").replace(/[^a-zA-Z0-9_-]/g, "").slice(0, 128);
  return {
    body: payload.body || "Você tem uma nova atualização.",
    tag: eventId || `arflow-${payload.phone || "notification"}`,
    renotify: true,
    data: { target:safePushTarget(payload), eventId },
    unreadCount: Number(payload.unreadCount) > 0 ? Number(payload.unreadCount) : 0,
  };
}